module.exports = __webpack_public_path__ + "img/waterfall-1.494f303.png";